import {useGlobals} from '../../../../../globalPropsContext';
import {AddToCartActionStatus} from '../../../../../constants';
import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';
import {isPurchaseUnavailable} from '../../productItemUtils';

export const useAddToCartState = (productId: string, cardIndex?: number) => {
  const {productsManifest, addedToCartStatus, unselectedOptionErrorSlotIndex} = useGlobals();

  const hasAddToCartUnselectedOptionError =
    addedToCartStatus[productId] === AddToCartActionStatus.UNSELECTED_OPTION_ERROR &&
    (cardIndex === undefined || unselectedOptionErrorSlotIndex === cardIndex);

  const isAddToCartEnabled = () => {
    if (hasAddToCartUnselectedOptionError) {
      return false;
    }

    if (isPurchaseUnavailable(productsManifest[productId])) {
      return false;
    }

    const {addToCartState} = productsManifest[productId];
    const isEnabledState = addToCartState === AddToCartState.ENABLED;
    const isPreOrderState = addToCartState === AddToCartState.PRE_ORDER;
    return isEnabledState || isPreOrderState;
  };

  return {isAddToCartEnabled, hasAddToCartUnselectedOptionError};
};
